export const SALE_CREATE_FORM_ID = Symbol("sale-create-form-id");
